module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-slider"
  }, [_c('div', {
    staticClass: "vux-swiper",
    style: ({
      height: _vm.xheight
    })
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "vux-swiper-item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.clickListItem(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('div', {
      staticClass: "vux-img",
      style: ({
        backgroundImage: _vm.buildBackgroundUrl(item)
      })
    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
      staticClass: "vux-swiper-desc"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.listTwoLoopItem), function(item, index) {
    return (_vm.listTwoLoopItem.length > 0) ? _c('div', {
      staticClass: "vux-swiper-item vux-swiper-item-clone",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.clickListItem(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('div', {
      staticClass: "vux-img",
      style: ({
        backgroundImage: _vm.buildBackgroundUrl(item)
      })
    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
      staticClass: "vux-swiper-desc"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDots),
      expression: "showDots"
    }],
    class: [_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]
  }, _vm._l((_vm.length), function(key) {
    return _c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('i', {
      staticClass: "vux-icon-dot",
      class: {
        'active': key - 1 === _vm.current
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7377e2a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/swiper/swiper.vue
// module id = 610
// module chunks = 0